const badgePhotos = {
  fireStarter: require('./FireStarterBadge.png'),
  ruckIt: require('./RuckItBadge.png'),
  oldGlory: require('./OldGloryBadge.png')
};

export default badgePhotos;
